import React from 'react';
import { Input, Form } from 'antd';

const Inputs = ({ label, name, value, onChange, type = 'text', rules, ...props }) => {
    return (
        <Form.Item
            label={label}
            name={name}
            rules={rules}
            style={{ marginBottom: 24 }}
        >
            <Input
                value={value}
                onChange={onChange}
                type={type}
                {...props}
                className='custom-inputs'
            />
        </Form.Item>
    );
};

export default Inputs;
